import { Controller } from "@hotwired/stimulus"

// Section and row switches (OAuth consent, API tokens), kept in the state they mean: a section
// and its rows agree, and nothing stays on that depends on something off (a
// strong action needs writing to that area). Convenience only: the server caps
// the grant from what is submitted, whatever this did or did not run.
//
//   data-section="<id>"   a row inside the section switch with that id
//   data-requires="<id>"  needs that switch on
export default class extends Controller {
  static targets = ["switch"]

  toggled({ target }) {
    if (!this.switchTargets.includes(target)) return

    this.#cascade(target)
    this.#syncSections()
  }

  #cascade(input) {
    for (const row of this.#rowsOf(input)) this.#set(row, input.checked)

    if (input.checked) {
      const required = this.switchTargets.find((other) => other.id === input.dataset.requires)
      if (required) this.#set(required, true)
    } else {
      for (const dependent of this.switchTargets.filter((other) => other.dataset.requires === input.id)) {
        this.#set(dependent, false)
      }
    }
  }

  #set(input, checked) {
    if (input.checked === checked) return

    input.checked = checked
    this.#cascade(input)
  }

  // A section is on while any of its rows is. The firm that cannot be switched
  // off is disabled and has no target, so it never holds its section on.
  #syncSections() {
    for (const section of this.switchTargets) {
      const rows = this.#rowsOf(section)
      if (rows.length > 0) section.checked = rows.some((row) => row.checked)
    }
  }

  #rowsOf(input) {
    return this.switchTargets.filter((other) => other.dataset.section === input.id)
  }
}
